import React, { useState } from "react";
import styles from "./inventorySliderComponents.module.scss";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import SelectDateRange from "./SelectDateRange";
import DateRangePicker from "./DateRangePicker/DateRangePicker";

const InventoryBulkBlock = ({
  setShow,
  baseUrl,
  property_id,
  userToken,
  fetchInfo,
  categories,
  currentDate,
  permissions,
  activeApp,
  room_id
}) => {

  // console.log("categories", categories) 
  const [selectedValues, setSelectedValues] = useState([]);
  const [blockInventoryData, setBlockInventoryData] = useState({
    property_id: property_id,
    from_date: "",
    to_date: "",
  });

  const blockInventoryDataUpdateHandle = async (e) => {
    e.preventDefault();

    // console.log("called");

    try {
      const response = await fetch(
        `${baseUrl}/api/v1/inventories/block/${property_id?.id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            ...blockInventoryData,
            room_categories: selectedValues,
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        showSuccessToast(data.message);
        fetchInfo(property_id?.id, room_id, "channel_view");
        setShow(false);
      } else {
        showErrorToast(data.message || "An error occurred.");
        console.log("Post request failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
      showErrorToast("An error occurred while processing your request.");
    }
  };

  const blockInventory = async (e) => {
    e.preventDefault();
    const headers = {
      "X-Channel-Token": "PoGC1kGsepDYT7lQ4Azqmmou03oqFbHA    mmm",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${userToken}`,
      "Cookie": process.env.REACT_APP_COOKIE,
    };

    const body = JSON.stringify({
      hotelCode: property_id,
      roomCode: selectedValues,
      type: "block",
      "from-date": blockInventoryData?.from_date,
      "to-date": blockInventoryData?.to_date
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v2/channel-manager/inventory/block`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow"
        }
      );

      const result = await response.json();
      console.log(result);
    } catch (error) {
      console.error("Error blocking inventory:", error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      // Check if the value is not already in the array before adding it
      if (!selectedValues.includes(value)) {
        setSelectedValues([...selectedValues, value]);
        addCheckbox();
      }
    } else {
      // Remove the value from the array if it exists
      setSelectedValues(selectedValues?.filter((item) => item !== value));
    }
  };

  const addCheckbox = () => {
    const newCheckbox = {
      id: Date.now(),
      label: `Option ${checkboxOptions.length + 1}`,
      value: `option${checkboxOptions.length + 1}`,
    };

    setCheckboxOptions([...checkboxOptions, newCheckbox]);
  };

  const [checkboxOptions, setCheckboxOptions] = useState([]);

  return (
    <>
      <div className={styles.container}>
        <div>
          <span style={{ paddingBottom: "5px" }}>Select Date Range</span>
          <div style={{ paddingTop: "5px" }}>
            {/* <SelectDateRange
              dataFromChild={(from_date, to_date) => {
                setBlockInventoryData({
                  ...blockInventoryData,
                  from_date: from_date,
                  to_date: to_date,
                });
              }}
              minDate={new Date(currentDate)}
            /> */}

            <DateRangePicker
              size={"medium"}
              onChange={(from_date, to_date) =>
                setBlockInventoryData({
                  ...blockInventoryData,
                  from_date: from_date,
                  to_date: to_date,
                })
              }
              // disabled={index === dateRanges.length - 1 ? false : true}
              minDate={new Date(currentDate)}
            />
          </div>
        </div>
        <hr />

        <div>
          <div className="form-container-div">
            <div
              style={{
                color: "#333",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "10px",
              }}
            >
              Select Room Categories
            </div>

            <div
              style={{
                display: "flex",
                gap: "10px",
                color: "#333",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "400",
                flexDirection: "column",
              }}
            >
              {categories?.map((room) => {
                return (
                  <div>
                    <input
                      type="checkbox"
                      name="update_type"
                      onChange={handleCheckboxChange}
                      value={room.roomId}
                      style={{ marginRight: "10px" }}
                    />
                    {room.name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="form-container-div-half"></div>
      </div>

      <div
        className={`flex align_items_center flex_gap_10 ${styles.buttonContainer}`}
      >
        {/* {activeApp === "pms" ? (
    permissions?.includes("update_block_inventory") ? (
      <BgThemeButton
        onClick={blockInventoryDataUpdateHandle}
        children={"Update"}
      />
    ) : (
      <Tooltip content={`Please contact your admin.`} dismissOnMouseOut>
        <BgThemeButtonDisabled type="submit" children={"Update"} />
      </Tooltip>
    )
  ) : (
    <BgThemeButton
      onClick={blockInventoryDataUpdateHandle}
      children={"Update"}
    />
  )}
  <Button onClick={() => setShow(false)}>Cancel</Button> */}

        <button
         disabled
          type="submit"
          style={{opacity: 0.5}}
          // className="vendor_common_property pointer"
          onClick={blockInventory}>Update</button>

        {/* <button onClick={handleCloseBookingSlider}>Cancel</button> */}

        <button
          className="no_logout_btn"
          onClick={() => setShow(false)}>
          Cancel
        </button>

      </div>

    </>
  );
};

export default InventoryBulkBlock;
